export default __webpack_public_path__ + "static/figure-pear-reference-b7981bb6515b617a29d0d5553e5f0f6c.jpg";